export default {
    showVariationsModal: {
        copy: 'Copia',
        contentVariation: 'Variante di contenuto.',
        chosenContent: 'Contenuto scelto',
        chosenContentPlaceholder: 'Per favore, inserisci.',
        continue: 'Continua.',
        generateNewContent: 'Generare nuovo contenuto.',
        type: 'Tipo:',
        contentTitle: 'Titolo:',
        descriptionLabel: 'Descrizione:',
        keywordsLabel: 'Parole chiave:',
        writingTone: 'Tonalità di scrittura:',
        context: 'Contesto:',
        cancel: 'Annulla',
    },
};
